import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './modules/campaign/landing/landing.component';
import { PlayComponent } from './modules/campaign/play/play.component';
import { AdminComponent } from './modules/admin/admin.component';
import { LayoutComponent } from './modules/page-layout/layout/layout.component';
import { WinComponent } from './modules/campaign/play/win/win.component';
import { NoWinComponent } from './modules/campaign/play/no-win/no-win.component';
import { FeedbackComponent } from './modules/support/feedback/feedback.component';
import { EmailReminderComponent } from './modules/shared/email-reminder/email-reminder.component';
import { ClickToPlayComponent } from './modules/campaign/click-to-play/click-to-play.component';
import { FeedbackSuccessComponent } from './modules/support/feedback-success/feedback-success.component';
import { CookieComponent } from './modules/support/cookie/cookie.component';
import { RedirectionGuard } from './core/guards/redirection.guard';
import { SelectSlotComponent } from './modules/campaign/select-slot/select-slot.component';
import { EnterCodeComponent } from './modules/campaign/enter-code/enter-code.component';
import { ParticipateWithEmailComponent } from './modules/campaign/participate-with-email/participate-with-email.component';
import { AnalyticsComponent } from './modules/analytics/analytics.component';



const routes: Routes = [

  //Default - Finnish
  { path: 'test-win', component: WinComponent, canActivate: [RedirectionGuard] },
  { path: 'test-no-win', component:NoWinComponent, canActivate: [RedirectionGuard]},
  { path: '', component: LandingComponent, },
  { path: 'play', component: PlayComponent },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'reminder', component: EmailReminderComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'click-to-play', component: ClickToPlayComponent },
  { path: 'feedback/success', component: FeedbackSuccessComponent },
  { path: 'cookie', component: CookieComponent },
  { path: 'select-slot', component: SelectSlotComponent },
  { path: 'enter-code', component: EnterCodeComponent },
  { path: 'register', component: ParticipateWithEmailComponent },
  { path: 'analytics', component: AnalyticsComponent },
  { path: '*', redirectTo: '' },
  { path: '**', redirectTo: '' }

  // { path: '', component: LandingComponent, pathMatch: 'full' },
  // { path: 'se', component: LandingSeComponent },
  // { path: 'home/:type', component: HomeComponent },
  // { path: 'play', component: PlayComponent },
  // { path: 'rules', component: RulesComponent },
  // { path: 'feedback', component: FeedbackComponent },
  // { path: 'feedback/success', component: FeedbackSuccessComponent },
  // { path: 'admin', component: AdminComponent },
  // { path: 'upload', component: PlayWithReceiptComponent },
  // { path: '*', redirectTo: '' },
  // { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 100] // [x, y]
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
